import React from 'react';
import { useRangeSlider } from '../hooks/useRangeSlider';
import config from '../config/config';
import SearchFiltersNumeric from './generic/SearchFiltersNumeric';
import { useSearchStateFilters, useSearchStateFiltersDispatch } from '../hooks/useSearchStateFilters';
import useRangeSliderData from '../hooks/useRangeSliderData';
import SearchFiltersToggle from './generic/SearchFiltersToggle';

/*
    Filter for gargaes
*/
const SearchFilterGarages = () => {
	const dispatch = useSearchStateFiltersDispatch();
	const { garages } = useSearchStateFilters();
	const minRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.garageMin, step: 1 } );
	const maxRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.garageMax, step: 1 } );

	const { isReady, ranges } = useRangeSliderData( { minRangeSlider, maxRangeSlider } );

	const onChange = ( { min = null, max = null } ) => {
		dispatch( {
			type: 'changed',
			garages: { min, max },
		} );
	};

	if ( ! isReady ) {
		return null;
	}
	// console.log( 'garages', minRangeSlider, maxRangeSlider, ranges );

	return (
		<div>
			<SearchFiltersNumeric
				ranges={ranges}
				id="garages"
				options={config.FILTER_OPTIONS_GARAGE}
				onChange={onChange}
				label="Garages"
				activeMin={garages.min}
				activeMax={garages.max}
			/>
			<div className='-tw-mt-4'>
				<SearchFiltersToggle
					attribute={config.FILTER_ATTRIBUTES.garageRV}
					label="Additional RV Garage/Parking Available"
				/>
			</div>
		</div>
	);
};

export default SearchFilterGarages;

